import { render, staticRenderFns } from "./AufmassForm.vue?vue&type=template&id=638b3f10&scoped=true&"
import script from "./AufmassForm.vue?vue&type=script&lang=js&"
export * from "./AufmassForm.vue?vue&type=script&lang=js&"
import style0 from "./AufmassForm.vue?vue&type=style&index=0&id=638b3f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b3f10",
  null
  
)

export default component.exports